import {createAction} from '@reduxjs/toolkit'

import {CashReceiptIssueTypeType, CashReceiptIssueUsageType} from '@web/core/constants'

/** 신청 | 신청안함 선택 */
export const setApplying = createAction<Maybe<CashReceiptIssueUsageType>>('cashReceipt/setApplying')

export const setIsEdit = createAction<boolean>('cashReceipt/setIsEdit')

export const setIssueType = createAction<CashReceiptIssueTypeType>('cashReceipt/setIssueType')

export const setIssueNumber = createAction<{
    numberType: Exclude<CashReceiptIssueTypeType, 'PR_SOCIAL_NUMBER'>
    value: string[]
}>('cashReceipt/setIssueNumber')

export const setIssueNumberElement = createAction<{
    numberType: Exclude<CashReceiptIssueTypeType, 'PR_SOCIAL_NUMBER'>
    value: string
    index: number
}>('cashReceipt/setIssueNumberElement')

export const toggleShouldBeSaved = createAction<boolean>('cashReceipt/toggleShouldBeSaved')

export const setCashReceiptInfo = createAction<{
    applied: boolean
    issueNumber: string[]
    issueType: Exclude<CashReceiptIssueTypeType, 'PR_SOCIAL_NUMBER'>
    shouldBeSaved: boolean
}>('cashReceipt/setCashReceiptInfo')
